export function isInvalidRefreshTokenError(error) {
  if (!error) return false;
  const message = `${error.message || ''} ${error.name || ''}`.toLowerCase();
  return message.includes('invalid refresh token')
    || message.includes('refresh token not found')
    || message.includes('refresh_token_not_found');
}

export async function clearInvalidLocalSession(client) {
  try {
    await client.auth.signOut({ scope: 'local' });
  } catch {
    // O token já está inválido no servidor; a limpeza local é suficiente.
  }
}
